// extracted by mini-css-extract-plugin
module.exports = {"video_list":"video_list-e2rIS6n-"};